import * as React from 'react';

import { Alert, Button, Typography } from 'antd';

import ConfirmationAlert from 'components/Alert';
import webhookService from 'v2/services/webhook2';

type UnifyUrlData = {
  allUrlsAreUnified: boolean;
  duplicatedCount: number;
};

export default function UnifyDuplicatedUrl() {
  const [loading, setLoading] = React.useState<boolean>();
  const [data, setData] = React.useState<UnifyUrlData>({
    allUrlsAreUnified: true,
    duplicatedCount: 0
  });

  const hasUrlsToUnify = async () => {
    try {
      const nextData = await webhookService.hasUrlsToUnify();

      setData(nextData);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    hasUrlsToUnify();
  }, []);

  const askForConfirmation = async () => {
    const confirm = await ConfirmationAlert.show({
      message: (
        <div className='flex flex-col gap-2'>
          <Typography.Paragraph className='mb-0'>
            Agora, você pode criar um Webhook para mais de 1 ou 2 produtos. Unifique suas URLs duplicadas e gerencie
            seus dados sem redundância, garantindo precisão em suas análises.
          </Typography.Paragraph>
          <Typography.Text type='secondary' className='text-sm'>
            * As mudanças podem levar até alguns minutos para serem refletidas.
          </Typography.Text>
        </div>
      ),
      title: 'Simplifique suas integrações com essa novidade!',
      confirmation: true
    });

    if (confirm) {
      await webhookService.unifyUrls();
      setLoading(false);
      setData({
        allUrlsAreUnified: true,
        duplicatedCount: 0
      });
    }
  };

  if (loading || data.allUrlsAreUnified) {
    return null;
  }

  return (
    <Alert
      type='info'
      showIcon
      message='Temos uma novidade para você!'
      description={
        <Typography.Paragraph className='mb-0'>
          Agora, você pode configurar um webhook para receber notificações de diversos produtos em um mesmo webhook.
          Isso diminui a quantidade de configurações necessárias e facilita a integração com a nossa plataforma.
        </Typography.Paragraph>
      }
      action={
        <Button id='webhook-v2-button-unify-products' type='primary' onClick={() => askForConfirmation()}>
          Unificar Webhooks
        </Button>
      }
    />
  );
}
